<div class="gap-page">

  <!-- ============== Filter type (same idea as SKU Pricing) ============== -->
  <div class="mode-bar">
    <rms-radio name="gapMode" label="Filter Type" [flexRow]="true" [options]="ModeOptions"
               [ngModel]="Mode" (ngModelChange)="onModeChange($event)"></rms-radio>

    @if (IsCustom) {
    <div class="f-custom">
      <rms-select name="gapCustomGroup" label="Custom Group" placeholder="Pick one of your custom groups"
                  [options]="CustomGroups" labelKey="CustomGroupFilterName" valueKey="CustomGroupFilterID"
                  [ngModel]="SelectedCustomGroupID" (ngModelChange)="onCustomGroupChange($event)"></rms-select>
    </div>
    <button mat-button class="btn-bg-yellow" (click)="viewCustomFilters()">
      <mat-icon>tune</mat-icon>View Custom Filters
    </button>
    }
  </div>

  <!-- ============== Filter bar ============== -->
  <div class="filter-bar">
    @if (Mode === 'Single') {
    <div class="f-country">
      <rms-select name="gapCountry" label="Country" placeholder="Pick a country" [options]="CountryOptions" [includeSearch]="true"
                  [ngModel]="SelectedCountry" (ngModelChange)="onCountryChange($event)"
                  [disabled]="LoadingOptions"></rms-select>
    </div>
    <div class="f-group">
      <rms-select name="gapGroup" label="Common Group (Next Export Month)"
                  [placeholder]="SelectedCountry === null ? 'Pick a country first' : 'Pick a group'"
                  [options]="GroupOptions" [includeSearch]="true" [(ngModel)]="SelectedGroup" (ngModelChange)="queueRefresh()"
                  [disabled]="LoadingOptions || SelectedCountry === null"></rms-select>
    </div>
    }

    <div class="f-burn">
      <rms-select name="gapBurnRange" label="Burn range" [options]="BurnRangeOptions"
                  [(ngModel)]="Filters.BurnRange" (ngModelChange)="queueRefresh()"></rms-select>
    </div>
    <div class="f-safs">
      <rms-number name="gapSafsValue" label="SAFS (growth)" [(ngModel)]="Filters.SafsValue" (ngModelChange)="queueRefresh()" min="0"></rms-number>
    </div>
    <div class="f-safs-type">
      <rms-select name="gapSafsType" label="SAFS type" [options]="SafsTypeOptions" [(ngModel)]="Filters.SafsType" (ngModelChange)="queueRefresh()"></rms-select>
    </div>
    <div class="f-crop">
      <rms-select name="gapCrop" label="Crop cycles" [options]="CropOptions" [(ngModel)]="Filters.CropOption" (ngModelChange)="queueRefresh()"></rms-select>
    </div>
    <div class="f-days">
      <rms-number name="gapDaysInAdj" label="Days-in adj." [(ngModel)]="Filters.DaysInAdj" (ngModelChange)="queueRefresh()"></rms-number>
    </div>
    <div class="f-checks">
      <rms-checkbox name="gapVolatile" [small]="true" label="Volatile market" [(ngModel)]="Filters.VolatileMarket" (ngModelChange)="queueRefresh()"></rms-checkbox>
      <rms-checkbox name="gapFireSales" [small]="true" label="Exclude fire sales" [(ngModel)]="Filters.ExcludeFireSales" (ngModelChange)="queueRefresh()"></rms-checkbox>
      <rms-checkbox name="gapInactive" [small]="true" label="Show inactive groups"
                    [ngModel]="ShowInactive" (ngModelChange)="onShowInactiveChange($event)"></rms-checkbox>
    </div>
    <div class="f-run">
      <button mat-stroked-button (click)="clearAll()">
        <mat-icon>filter_alt_off</mat-icon>Clear all filters
      </button>
      @if (FiltersChanged) {
      <span class="run-hint"><mat-icon>info</mat-icon>Updating automatically…</span>
      }
      <button mat-flat-button class="btn-bg-green" [class.run-pulse]="FiltersChanged" (click)="viewReport()" [disabled]="!CanRun">
        <mat-icon>refresh</mat-icon>Refresh
      </button>
    </div>
  </div>

  <!-- ============== Custom group: what is inside it ============== -->
  @if (IsCustom) {
  <div class="custom">
    @if (!CustomGroups.length) {
    <div class="hint">
      You have no custom groups yet. Click <b>View Custom Filters</b> → <b>Create Group Filter</b>,
      or build one in <b>Multi-Group</b> and click <b>Save as custom group</b>. The same list is used in SKU Pricing.
    </div>
    } @else if (!SelectedCustomGroup) {
    <div class="hint">Pick one of your {{ CustomGroups.length }} custom groups. They are the same ones you use in SKU Pricing.</div>
    } @else {
    <div class="custom-head">
      <b>{{ SelectedCustomGroup.CustomGroupFilterName }}</b>
      @if (SelectedCustomGroup.PrimaryFilter) { <span class="primary">Primary</span> }
      <span class="hint">{{ CustomGroupItems.length - MissingCustomCount }} group{{ CustomGroupItems.length - MissingCustomCount === 1 ? '' : 's' }} — analysed together</span>
    </div>
    <div class="picked">
      @for (i of CustomGroupItems; track i.GroupID) {
      <span class="pick-chip static" [class.missing]="i.Missing"
            [title]="i.Missing ? 'This group has no SKUs (or no longer exists), so it is left out' : ''">{{ i.Name }}</span>
      }
    </div>
    @if (MissingCustomCount) {
    <div class="hint warn">{{ MissingCustomCount }} group(s) in this filter have no SKUs and are left out.</div>
    }
    }
  </div>
  }

  <!-- ============== Multi-Group Mode: search + tick groups ============== -->
  @if (IsMulti) {
  <div class="multi">
    <div class="multi-head">
      <div class="multi-search">
        <rms-input name="gapMultiSearch" label="Search groups (name or country)" [(ngModel)]="MultiSearch"></rms-input>
      </div>
      <button mat-stroked-button (click)="pickAllMatches()" [disabled]="!MultiMatches.length">
        <mat-icon>done_all</mat-icon>Add all {{ MultiMatches.length }} matches
      </button>
      <button mat-stroked-button (click)="saveAsCustomGroup()" [disabled]="!Picked.length || SavingCustom"
              title="Keep this pick — it shows under Custom Group Filter here and in SKU Pricing">
        <mat-icon>bookmark_add</mat-icon>{{ SavingCustom ? 'Saving…' : 'Save as custom group' }}
      </button>
      <span class="multi-count">{{ Picked.length }} group{{ Picked.length === 1 ? '' : 's' }} picked — analysed together</span>
    </div>

    @if (Picked.length) {
    <div class="picked">
      @for (g of Picked; track g.GroupID) {
      <button type="button" class="pick-chip" (click)="unpick(g)" title="Remove">
        {{ g.Label }} <mat-icon>close</mat-icon>
      </button>
      }
    </div>
    }

    <div class="matches">
      @for (g of MultiMatches; track g.GroupID) {
      <button type="button" class="match" (click)="pick(g)">
        <mat-icon>add</mat-icon>
        <span class="m-name">{{ g.Label }}</span>
        <span class="m-meta">{{ g.CountryName }} · {{ g.SkuCount }} SKUs</span>
      </button>
      } @empty {
      <div class="hint">
        @if (SearchHitCount > 0) { All {{ SearchHitCount }} matching groups are picked. }
        @else { No groups match "{{ MultiSearch }}". }
      </div>
      }
    </div>
  </div>
  }

  <!-- ============== The report ============== -->
  @for (k of RunKeys; track k) {
  <div class="report">
    <app-group-analysis [groupIds]="RunGroupIDs" [filters]="RunFilters" [reportTitle]="RunTitle"></app-group-analysis>
  </div>
  } @empty {
  <div class="empty">
    <mat-icon>insights</mat-icon>
    <div>Pick a <b>country</b> and a <b>coffee group</b>. Your analysis opens automatically.</div>
    <div class="hint">
      Or switch <b>Filter Type</b> to <b>Custom Group Filter</b> (your saved groups, same as SKU Pricing)
      or <b>Multi-Group</b> to analyse several groups together.
    </div>
  </div>
  }

</div>
